import Modal from '../Modal'
import { Container } from './styles'
import { GrFormClose } from 'react-icons/gr'
import { useAsyncFn } from 'react-use'
import { useSWRConfig } from 'swr'
import { toast } from 'react-toastify'
import { FiAlertCircle } from 'react-icons/fi'
import { TQuestionBook } from 'pages/Questions/components/QuestionsContent/types'
import VerticalBook from 'assets/icons/vertical-book'
import Loader from 'assets/icons/loader'
import { DELETE_QUESTION_BOOK } from 'pages/MyQuestionBooks/services'

interface IProps {
  questionBook: TQuestionBook
  isOpen: boolean
  onClose(): void
}

const DeleteModal = (props: IProps) => {
  const { mutate } = useSWRConfig()
  const token = localStorage.getItem('token')

  const updateBooks = () => {
    mutate('/question/books', (prevState) => {
      const newState = [...prevState]
      const index = newState.findIndex((item) => item._id === props.questionBook._id)

      newState.splice(index, 1)

      return newState
    })
  }

  const [state, post] = useAsyncFn(async () => {
    try {
      await DELETE_QUESTION_BOOK(props.questionBook._id)

      updateBooks()

      toast.success('Caderno excluído com sucesso!')
    } catch {
      toast.error('Erro ao excluir caderno')
    }
  }, [token])

  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose}>
      <Container>
        <button className="close" onClick={props.onClose}>
          <GrFormClose size="100%" />
        </button>

        <FiAlertCircle className="alert-icon" />

        <p className="title">
          Tem certeza que deseja <br /> excluir o caderno?
        </p>

        <p className="description">
          <VerticalBook className="icon" />
          {props.questionBook.name}
        </p>

        <div className="buttons">
          <button className="delete" disabled={state.loading} onClick={post}>
            {state.loading ? <Loader className="loader" /> : 'Excluir'}
          </button>
          <button className="cancel" onClick={props.onClose}>
            Cancelar
          </button>
        </div>
      </Container>
    </Modal>
  )
}

export default DeleteModal
